export const calculateDraftProductPricing = ({
  baseUnitPrice,
  variantExtra = 0,
  quantity,
  pricePerWeight = false,
  included = false,
}) => {
  if (included) return { displayUnitPrice: 0, lineTotal: 0 };

  const base = Number(baseUnitPrice || 0);
  const extra = Number(variantExtra || 0);
  const qty = Number(quantity || 0);

  if (pricePerWeight) {
    return {
      displayUnitPrice: base,
      lineTotal: (base * qty) + extra,
    };
  }

  const displayUnitPrice = base + extra;
  return { displayUnitPrice, lineTotal: displayUnitPrice * qty };
};
